function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { Block } from "../../../custom_components/components/library/container";
import { Link } from "../../../custom_components/components/library/link";
import { trackNewsletterSubscription } from "../../../custom_components/components/library/tracking";
import { Loader } from "../../../custom_components/components/loader";
import { submitForm } from "./newsletterFormBlockApi";
import { allFields, genderLabels, genderValues, initialState, newsletterLabel, newsletterName, newslettersId, setFieldOnState, setVisited, toggleNewsletterOnState, validateFields, validateFormData } from "./newsletterFormBlockState";
const debounce = require("lodash.debounce");
import { classNamesConfig } from "../../../../Shared/features/classnames";
export class NewsletterForm extends React.Component {
    submit() {
        const validationMessages = validateFields(allFields, this.state.data);
        if (validationMessages.count() > 0) {
            this.setState((prevState)=>({
                    ...prevState,
                    validationMessages
                }));
            return;
        }
        this.setState((prevState)=>({
                ...prevState,
                status: 'submitting'
            }), async ()=>{
            const response = await submitForm(this.state.data);
            if (response.kind == 'result') trackNewsletterSubscription();
            // Handle failed request
            if (response.kind == 'failedWithMessage') {
                var message = response.message;
                console.error(response.message);
                this.setState((s0)=>({
                        ...s0,
                        errorMessage: message
                    }));
            }
            this.setState((prevState)=>({
                    ...prevState,
                    status: response.kind == 'result' ? 'succeeded' : 'failed'
                }));
        });
    }
    maybeShowMessage(field) {
        const messages = this.state.validationMessages;
        return messages.has(field) ? /*#__PURE__*/ _jsx("p", {
            id: `nfd-${field}`,
            className: "form__description form__error",
            children: messages.get(field)
        }) : /*#__PURE__*/ _jsx(_Fragment, {});
    }
    render() {
        if (this.state.status == 'submitting') return submitting;
        if (this.state.status == 'succeeded') return succeeded;
        if (this.state.status == 'failed') return /*#__PURE__*/ _jsx(_Fragment, {
            children: failed(this.state.errorMessage)
        });
        const setField = setFieldOnState(this.setState.bind(this));
        const set = (field)=>(e)=>{
                setField(field)(e.target.value);
                this.validateVisitedAfterDelay();
            };
        const toggler = toggleNewsletterOnState(this.setState.bind(this));
        const toggleNewsletter = (newsletter)=>{
            toggler(newsletter);
            this.validateVisitedAfterDelay();
        };
        const setVisit = setVisited(this.setState.bind(this));
        const visit = (field)=>()=>setVisit(field);
        const { firstName, lastName, emailAddress, gender, newsletters: selectedNewsletters } = this.state.data;
        const canSubmit = this.state.validationMessages.size == 0;
        return /*#__PURE__*/ _jsx(Block, {
            children: /*#__PURE__*/ _jsx("div", {
                className: `newsletter-form ${this.classNames.block}`,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: `${this.classNames.inner}`,
                    children: [
                        /*#__PURE__*/ _jsxs("fieldset", {
                            children: [
                                /*#__PURE__*/ _jsx("legend", {
                                    className: "form__title title--l container--xs",
                                    children: "Persoonlijke informatie"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "container--s",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "form__group form__group--name",
                                            children: [
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "form__field",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("label", {
                                                            className: "form__label search__label form__label--required",
                                                            htmlFor: "emailAddress",
                                                            children: "E-mailadres"
                                                        }),
                                                        /*#__PURE__*/ _jsx("input", {
                                                            className: "form__input",
                                                            name: "emailAddress",
                                                            type: "email",
                                                            id: "emailAddress",
                                                            onFocus: visit('emailAddress'),
                                                            onChange: set('emailAddress'),
                                                            value: emailAddress,
                                                            "aria-invalid": this.state.validationMessages.has("emailAddress") ? true : undefined,
                                                            "aria-errormessage": this.state.validationMessages.has("emailAddress") ? `nfd-emailAddress` : undefined,
                                                            "aria-required": true
                                                        }),
                                                        this.maybeShowMessage('emailAddress')
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "form__field form__field--long",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("label", {
                                                            className: "form__label search__label",
                                                            htmlFor: "firstName",
                                                            children: "Voornaam"
                                                        }),
                                                        /*#__PURE__*/ _jsx("input", {
                                                            className: "form__input",
                                                            name: "firstName",
                                                            type: "text",
                                                            id: "firstName",
                                                            onFocus: visit('firstName'),
                                                            onChange: set('firstName'),
                                                            value: firstName
                                                        }),
                                                        this.maybeShowMessage('firstName')
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "form__field form__field--long",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("label", {
                                                            className: "form__label search__label form__label--required",
                                                            htmlFor: "lastName",
                                                            children: "Achternaam"
                                                        }),
                                                        /*#__PURE__*/ _jsx("input", {
                                                            className: "form__input",
                                                            name: "lastName",
                                                            type: "text",
                                                            id: "lastName",
                                                            onFocus: visit('lastName'),
                                                            onChange: set('lastName'),
                                                            value: lastName,
                                                            "aria-invalid": this.state.validationMessages.has("lastName") ? true : undefined,
                                                            "aria-errormessage": this.state.validationMessages.has("lastName") ? `nfd-lastName` : undefined,
                                                            "aria-required": true
                                                        }),
                                                        this.maybeShowMessage('lastName')
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "form__field",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "form__label search__label",
                                                    children: "Geslacht"
                                                }),
                                                genderValues.map((g)=>/*#__PURE__*/ _jsxs("div", {
                                                        className: "form__radio",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("input", {
                                                                className: "form__input--radio",
                                                                type: "radio",
                                                                name: "gender",
                                                                value: g,
                                                                id: `gender-${g}`,
                                                                checked: gender == g,
                                                                onChange: ()=>setField('gender')(g)
                                                            }),
                                                            /*#__PURE__*/ _jsx("label", {
                                                                className: "form__label--radio",
                                                                htmlFor: `gender-${g}`,
                                                                children: genderLabels[g]
                                                            })
                                                        ]
                                                    }, g))
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "form__field",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "form__label search__label form__label--required",
                                                    children: "Ik wil me inschrijven voor de"
                                                }),
                                                newslettersId.map((newsletter)=>/*#__PURE__*/ _jsxs("div", {
                                                        className: "form__checkbox",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("input", {
                                                                id: `nieuwsbrief-${newsletter}`,
                                                                className: "form__input--checkbox",
                                                                type: "checkbox",
                                                                name: newsletterName[newsletter],
                                                                value: newsletterName[newsletter],
                                                                checked: selectedNewsletters.includes(newsletter),
                                                                onChange: ()=>toggleNewsletter(newsletter),
                                                                "aria-invalid": this.state.validationMessages.has("newsletters") ? true : undefined,
                                                                "aria-errormessage": this.state.validationMessages.has("newsletters") ? `nfd-newsletters` : undefined,
                                                                "aria-describedby": `nfd-nieuwsbrief-${newsletter}`
                                                            }),
                                                            /*#__PURE__*/ _jsx("label", {
                                                                className: "form__label--checkbox",
                                                                htmlFor: `nieuwsbrief-${newsletter}`,
                                                                children: newsletterName[newsletter]
                                                            }),
                                                            /*#__PURE__*/ _jsx("p", {
                                                                id: `nfd-nieuwsbrief-${newsletter}`,
                                                                className: "form__description",
                                                                children: newsletterLabel[newsletter]
                                                            })
                                                        ]
                                                    }, newsletterName[newsletter])),
                                                this.maybeShowMessage('newsletters')
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            className: "button button--primary",
                            disabled: !canSubmit,
                            onMouseOver: ()=>this.validate(true),
                            onClick: ()=>this.submit(),
                            children: "Verstuur"
                        })
                    ]
                })
            })
        });
    }
    constructor(props){
        super(props), _define_property(this, "validate", validateFormData(this.setState.bind(this))), _define_property(this, "validateVisitedAfterDelay", debounce(()=>this.validate(), 1000)), _define_property(this, "classNames", classNamesConfig().newsletter_signup_form);
        this.state = initialState;
    }
}
const submitting = /*#__PURE__*/ _jsx(Block, {
    children: /*#__PURE__*/ _jsx("div", {
        className: "newsletter-form newsletter-form--submitting container--lg align--center",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container--m align--center",
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "form__title title--l container--xs",
                    children: "Bezig met versturen"
                }),
                /*#__PURE__*/ _jsx(Loader, {})
            ]
        })
    })
});
const succeeded = /*#__PURE__*/ _jsx(Block, {
    children: /*#__PURE__*/ _jsx("div", {
        className: "newsletter-form newsletter-form--succeeded container--lg align--center",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container--m align--center",
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "form__title title--l container--xs",
                    children: "Inschrijving verstuurd"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "container--s text--styled",
                    children: /*#__PURE__*/ _jsx("p", {
                        children: "Bedankt voor het aanmelden voor de nieuwsbrief! We hebben je gegevens verwerkt zodat je de nieuwsbrief binnenkort ontvangt."
                    })
                })
            ]
        })
    })
});
const failed = (errorMessage)=>/*#__PURE__*/ _jsx(Block, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "newsletter-form newsletter-form--failed container--lg align--center",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "container--m align--center",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "form__title title--l container--xs",
                        children: "Het inschrijven is mislukt"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "container--s text--styled",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                children: "Er is iets misgegaan tijdens het aanmelden voor de nieuwsbrief. Herlaadt deze pagina en probeer het nog eens."
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "form_error_message",
                                children: errorMessage
                            }),
                            /*#__PURE__*/ _jsxs("p", {
                                children: [
                                    "Lukt het nog steeds niet? Neem dan ",
                                    /*#__PURE__*/ _jsx(Link, {
                                        url: "/klantenservice",
                                        children: "contact"
                                    }),
                                    " met ons op."
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
